/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CsSellItemDto } from '../models/PagedResultDto_CsSellItemDto';
import type { Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult } from '../models/Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseResponseDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseResponseDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsDoneTradePreviewDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsDoneTradePreviewDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitResponseDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitResponseDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CsBrokerTradeToolService {

    /**
     * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolBookingTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/booking-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolReasonCodes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_BrokerTradeTool_CsLabelValueDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/reason-codes',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param companyId 
     * @param skipCount 
     * @param maxResultCount 
     * @param recordTypeName 
     * @param awardType 
     * @returns PagedResultDto_CsSellItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolParticipantSellItems(
participantId: string,
companyId?: string,
skipCount?: number,
maxResultCount: number = 10,
recordTypeName?: string,
awardType?: string,
): CancelablePromise<PagedResultDto_CsSellItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/participant/{participantId}/sell-items',
            path: {
                'participantId': participantId,
            },
            query: {
                'companyId': companyId,
                'skipCount': skipCount,
                'maxResultCount': maxResultCount,
                'recordTypeName': recordTypeName,
                'awardType': awardType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolSubmit(
requestBody?: Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs/broker-trade-tool/submit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_CsDoneTradePreviewDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolPrepareDoneTrade(
requestBody?: Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_BrokerTradeTool_CsDoneTradePreviewDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs/broker-trade-tool/prepare-done-trade',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolCalculateExercise(
requestBody?: Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_BrokerTradeTool_CsCalculateExerciseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs/broker-trade-tool/calculate-exercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolOptionAwardOverview(
companyId?: string,
optionAwardId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/option-award-overview',
            query: {
                'companyId': companyId,
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolRsuAwardOverview(
companyId?: string,
rsuAwardId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/rsu-award-overview',
            query: {
                'companyId': companyId,
                'rsuAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param psuAwardId 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolPsuAwardOverview(
companyId?: string,
psuAwardId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/psu-award-overview',
            query: {
                'companyId': companyId,
                'psuAwardId': psuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolRsuAwardVestingDate(
companyId?: string,
rsuAwardId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/rsu-award-vestingDate',
            query: {
                'companyId': companyId,
                'rsuAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param psuAwardId 
     * @returns Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolPsuAwardVestingDate(
companyId?: string,
psuAwardId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs/broker-trade-tool/psu-award-vestingDate',
            query: {
                'companyId': companyId,
                'psuAwardId': psuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolValidateCompanyAccessPublic(
companyId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs-broker-trade-tool/validate-company-access-public/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCsBrokerTradeToolCompanyTenantId(
companyId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/cs-broker-trade-tool/company-tenant-id/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param openLotId 
     * @param sellShares 
     * @param reasonCode 
     * @param assistingUserId 
     * @param bookingType 
     * @param companyId 
     * @returns Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolLongShareSellTransaction(
participantId?: string,
openLotId?: string,
sellShares?: number,
reasonCode?: string,
assistingUserId?: string,
bookingType?: string,
companyId?: string,
): CancelablePromise<Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs-broker-trade-tool/long-share-sell-transaction',
            query: {
                'participantId': participantId,
                'openLotId': openLotId,
                'sellShares': sellShares,
                'reasonCode': reasonCode,
                'assistingUserId': assistingUserId,
                'bookingType': bookingType,
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param awardId 
     * @param sellShares 
     * @param settlementTypeId 
     * @param reasonCode 
     * @param assistingUserId 
     * @param bookingType 
     * @param companyId 
     * @returns Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolOptionExerciseTransaction(
participantId?: string,
awardId?: string,
sellShares?: number,
settlementTypeId?: string,
reasonCode?: string,
assistingUserId?: string,
bookingType?: string,
companyId?: string,
): CancelablePromise<Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs-broker-trade-tool/option-exercise-transaction',
            query: {
                'participantId': participantId,
                'awardId': awardId,
                'sellShares': sellShares,
                'settlementTypeId': settlementTypeId,
                'reasonCode': reasonCode,
                'assistingUserId': assistingUserId,
                'bookingType': bookingType,
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @param vestingId 
     * @param sellShares 
     * @param fmv 
     * @param settlementTypeId 
     * @param reasonCode 
     * @param assistingUserId 
     * @param bookingType 
     * @param awardType 
     * @param companyId 
     * @returns Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCsBrokerTradeToolReleaseTransaction(
participantId?: string,
vestingId?: string,
sellShares?: number,
fmv?: number,
settlementTypeId?: string,
reasonCode?: string,
assistingUserId?: string,
bookingType?: string,
awardType?: string,
companyId?: string,
): CancelablePromise<Wealthlane_AwardService_AppServices_BrokerTradeTool_CsTransactionResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/cs-broker-trade-tool/release-transaction',
            query: {
                'participantId': participantId,
                'vestingId': vestingId,
                'sellShares': sellShares,
                'fmv': fmv,
                'settlementTypeId': settlementTypeId,
                'reasonCode': reasonCode,
                'assistingUserId': assistingUserId,
                'bookingType': bookingType,
                'awardType': awardType,
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
